import { render } from "./bottom-tips.vue?vue&type=template&id=1e0a99d0&scoped=true"
import script from "./bottom-tips.vue?vue&type=script&lang=js"
export * from "./bottom-tips.vue?vue&type=script&lang=js"

import "./bottom-tips.vue?vue&type=style&index=0&id=1e0a99d0&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0a99d0"]])

export default __exports__